// src/FleetDashboard.js
import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { Link } from 'react-router-dom';
import { db } from './firebase'; // Import db

function FleetDashboard() {
  const [tablets, setTablets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tabletsRef = collection(db, "tablets");
    const q = query(tabletsRef, orderBy("lastSeen", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tabletsData = [];
      querySnapshot.forEach((doc) => {
        tabletsData.push({ id: doc.id, ...doc.data() });
      });
      setTablets(tabletsData);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching tablets: ", error);
    });
    return () => unsubscribe();
  }, []);

  const isOnline = (lastSeen) => {
    if (!lastSeen) return false;
    // Check if last seen was within the last 2 minutes
    return (new Date() - lastSeen.toDate()) < 120000;
  };

  if (loading) return <p className="loading-text">Loading Fleet Data...</p>;

  return (
    <div className="card">
      <h1 className="page-header">Fleet Dashboard</h1>
      <p className="page-subheader">Tracking {tablets.length} active tablets in real-time.</p>
      <table className="table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Tablet ID</th>
            <th>Last Seen</th>
            <th>Battery</th>
            <th>App Version</th>
            <th>Location</th>
          </tr>
        </thead>
        <tbody>
          {tablets.map(tablet => (
            <tr key={tablet.id}>
              <td>
                <span className={`status-indicator ${isOnline(tablet.lastSeen) ? 'status-online' : 'status-offline'}`}></span>
                {isOnline(tablet.lastSeen) ? 'Online' : 'Offline'}
              </td>
              <td>
                <Link to={`/tablet/${tablet.id}`} className="btn-link">{tablet.id}</Link>
              </td>
              <td>{tablet.lastSeen ? tablet.lastSeen.toDate().toLocaleString() : 'Never'}</td>
              <td>{tablet.battery ? `${tablet.battery}%` : 'N/A'}</td>
              <td>{tablet.appVersion || 'N/A'}</td>
              <td>
                {tablet.currentLocation ? (
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${tablet.currentLocation.latitude},${tablet.currentLocation.longitude}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-link"
                  >
                    View on Map
                  </a>
                ) : (
                  'N/A'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default FleetDashboard;
